// extracted by mini-css-extract-plugin
module.exports = {"div_Cards":"Card_div_Cards__3oHrg","div_contenido":"Card_div_contenido__1kIR2","tit_img":"Card_tit_img__35fKD","div_rt":"Card_div_rt__37J0a","h3_rt":"Card_h3_rt__IGpVA"};